import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from '../baseQueryV1';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: baseQueryV1,
  tagTypes: ['Users'], // 👈 declare tag type
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => 'users', // GET /users
      providesTags: ['Users'],
    }),
    getUserById: builder.query({
      query: (id) => ({
        url: `users/${id}`, //  get by user endpoint
      }),
    }),
    updateEmployee: builder.mutation({
      query: ({ employeeData, id }) => ({
        url: `users/${id}`, //  update endpoint
        method: 'PUT',
        body: employeeData,
      }),
      invalidatesTags: ['Users'],
    }),
    updatePassword: builder.mutation({
      query: ({ payload, id }) => ({
        url: `users/update-password/${id}`, //  update endpoint
        method: 'PUT',
        body: payload,
      }),
    }),
    updateExperience: builder.mutation({
      query: ({ id, experienceData }) => ({
        url: `users/${id}/experience`,
        method: 'PUT',
        body: experienceData,
      }),
      // Optionally invalidate Users tag if needed
      invalidatesTags: ['Users'],
    }),
    getUserSessions: builder.query({
      query: ({ id, pageNo = 1, pageSize = 5 }) => ({
        url: `users/sessions?id=${id}`,
        params: { pageNo, pageSize },
      }),
      providesTags: ['Sessions'],
    }),
    getMySessions: builder.query({
      query: ({ pageNo = 1, pageSize = 5 }) => ({
        url: 'users/sessions',
        params: { pageNo, pageSize },
      }),
      providesTags: ['Sessions'],
    }),
    getEmployeeWorkProfile: builder.query({
      query: (id) => ({
        url: `users/${id}/work-profile`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['Users'],
    }),
    updateEmployeeWorkProfile: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `users/${id}/work-profile`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Users'],
    }),
    getContactNumbers: builder.query({
      query: (userId) => ({
        url: `users/contact-numbers/${userId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['Users'],
    }),
  }),
});

export const {
  getUsers,
  useGetUsersQuery,
  updateEmployeeMutation,
  useUpdateEmployeeMutation,
  getUserByIdQuery,
  useGetUserByIdQuery,
  updatePasswordMutation,
  useUpdatePasswordMutation,
  getUserSessionsQuery,
  useGetUserSessionsQuery,
  useGetMySessionsQuery,
  updateExperienceMutation,
  useUpdateExperienceMutation,
  useGetEmployeeWorkProfileQuery,
  useUpdateEmployeeWorkProfileMutation,
  useGetContactNumbersQuery,
} = usersApi;
